module.exports = __webpack_public_path__ + "static/img/service-05.cd2b4e2d.png";